import React from 'react';

import './../styles/step.css'

function Step({ title }) {
  return (
    <div className="step-container">
      <p className="step-title">{title}</p>
    </div>
  )
}

export default Step
